import { render, staticRenderFns } from "./news-classify.vue?vue&type=template&id=557158ee&"
import script from "./news-classify.vue?vue&type=script&lang=js&"
export * from "./news-classify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports